import { A11Y_MIN_SIZE, getRgbColorFromTheme } from "../utils";
export var BORDER_WIDTH = 2;
export var OUTLINE_WIDTH = 2;
export var OUTLINE_OFFSET = BORDER_WIDTH * -3;
export var REGULAR_BUTTON_HEIGHT = Math.max(48, A11Y_MIN_SIZE);
export var SMALL_BUTTON_WIDTH = 96;
export var REGULAR_BUTTON_WIDTH = 128;
export var TERTIARY_HORIZONTAL_PADDING = 16;
export var BORDER_RADIUS = '1000px';
export var primaryExpectedBgColor = getRgbColorFromTheme('primary70');
export var primaryExpectedColor = getRgbColorFromTheme('neutral0');
export var tertiaryExpectedBgColor = 'transparent';
export var tertiaryExpectedColor = getRgbColorFromTheme('primary70');